import { Box } from '@chakra-ui/react';
import { BlockConnectMenu } from './BlockConnectMenu';

export type OptionItemProps = {
  option: {
    id: string;
    title: string;
  };
  nodeId: string;
  isConnectable: boolean;
};

export function QuizOutgoingMenu({ nodeId, isConnectable, option }: OptionItemProps) {
  return (
    <BlockConnectMenu
      isConnectable={isConnectable}
      nodeId={nodeId}
      option={option}
      isQuizMenu={true}
    >
      <Box
        role="group"
        color={option.title === 'Correct' ? 'green.600' : 'red.600'}
        fontWeight="semibold"
      >
        {option.title}
      </Box>
    </BlockConnectMenu>
  );
}
